module.exports = __webpack_public_path__ + "img/user-default.2a097d33.svg";